import { render } from "./ForgotPasswordDialog.vue?vue&type=template&id=0ce00ef4&scoped=true"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"

import "./ForgotPasswordDialog.vue?vue&type=style&index=0&id=0ce00ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce00ef4"]])

export default __exports__